import { Component } from '@angular/core';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-popcorn-landing-page',
  templateUrl: './popcorn-landing-page.component.html',
  styleUrls: ['./popcorn-landing-page.component.scss'],
})
export class PopcornLandingPageComponent {
  constructor(private message: MessageService) {}

  downloadWindows(i: number) {
    // this.message.warn('正在开发中，敬请期待');
    if (i === 1) {
      //谷歌浏览器版本
      window.open('https://down.popcorn.plus/Popcorn.exe');
    } else if (i === 2) {
      //edge 4K 版本
      window.open('https://down.popcorn.plus/Popcorn-4k.exe');
    } else if (i === 3) {
      // Edge浏览器4K版（仅海外使用）
      window.open(
        'https://down.popcorn.plus/popcorn-abroad/Popcorn-abroad-4k.exe'
      );
    }
  }

  downloadmacOS(i: number) {
    if (i === 1) {
      //国内使用版
      window.open('https://down.popcorn.plus/Popcorn.dmg');
    } else if (i === 2) {
      //海外使用版
      window.open(
        'https://down.popcorn.plus/popcorn-abroad/abroad/Popcorn.dmg'
      );
    }
    // this.message.warn('正在开发中，敬请期待');
  }
}
